var storefrontApp = angular.module('storefrontApp');
storefrontApp.service('categoriesService', ['$http', function ($http) {
    return {
        getCategoriesInfo: function (prdType,fp) {
            return $http.get('getcategoriesinfo?prdType='+ prdType+'&fp='+fp);
        }
    }
}]);
